module.exports = __webpack_public_path__ + "img/1.abfc9c82.png";